export const ResumeJobActionTypes = {
  LOADING_CREATE_RESUME_JOB: 'LOADING_CREATE_RESUME_JOB',
  LOADING_RESUME_JOB: 'LOADING_RESUME_JOB',
  LOADING_SINGLE_RESUME_JOB: 'LOADING_SINGLE_RESUME_JOB',
  UPDATING_RESUME_JOB: 'UPDATING_RESUME_JOB',
  LOAD_RESUME_JOB_START: 'LOAD_RESUME_JOB_START',
  LOAD_RESUME_JOB_SUCCESS: 'LOAD_RESUME_JOB_SUCCESS',
  LOAD_RESUME_JOB_FAILURE: 'LOAD_RESUME_JOB_FAILURE',
  LOAD_LIST_RESUME_JOB_START: 'LOAD_LIST_RESUME_JOB_START',
  LOAD_LIST_RESUME_JOB_SUCCESS: 'LOAD_LIST_RESUME_JOB_SUCCESS',
  LOAD_LIST_RESUME_JOB_FAILURE: 'LOAD_LIST_RESUME_JOB_FAILURE',
  UPDATE_RESUME_JOB_IN_LIST: 'UPDATE_RESUME_JOB_IN_LIST',
  CREATE_RESUME_JOB_START: 'CREATE_RESUME_JOB_START',
  CREATE_RESUME_JOB_SUCCESS: 'CREATE_RESUME_JOB_SUCCESS',
  CREATE_RESUME_JOB_FAILURE: 'CREATE_RESUME_JOB_FAILURE',
  UPDATE_RESUME_JOB_START: 'UPDATE_RESUME_JOB_START',
  UPDATE_RESUME_JOB_SUCCESS: 'UPDATE_RESUME_JOB_SUCCESS',
  UPDATE_RESUME_JOB_FAILURE: 'UPDATE_RESUME_JOB_FAILURE',
  APPLY_RESUME_JOB_START: 'APPLY_RESUME_JOB_START',
  APPLY_RESUME_JOB_SUCCESS: 'APPLY_RESUME_JOB_SUCCESS',
  APPLY_RESUME_JOB_FAILURE: 'APPLY_RESUME_JOB_FAILURE',
  LOADING_APPLY_RESUME_JOB: 'LOADING_APPLY_RESUME_JOB',
  LOADING_INFO_CHART: 'LOADING_INFO_CHART',
  LOAD_INFO_CHART_START: 'LOAD_INFO_CHART_START',
  LOAD_INFO_CHART_FAILURE: 'LOAD_INFO_CHART_FAILURE',
  LOAD_INFO_CHART_SUCCESS: 'LOAD_INFO_CHART_SUCCESS',
  LOAD_INFO_CARD_START: 'LOAD_INFO_CARD_START',
  LOAD_INFO_CARD_SUCCESS: 'LOAD_INFO_CARD_SUCCESS',
};
